import { createContext, PropsWithChildren, useContext } from 'react';

export interface PageContentContextInterface {
	introText?: string;
	highlights?: string;
	methodology?: string;
	dataAppendix?: string;
	lastUpdated?: string;
	sectionHeadings: Record<string, string>;
	ussenateData?: string;
	ussenateDataDonorMoney?: string;
	ushouseData?: string;
	ushouseDataDonorMoney?: string;
	ussenateDataDonorCont?: string;
	ushouseDataDonorCont?: string;
}

const PageContentContext = createContext<PageContentContextInterface | undefined>(undefined);

type PageContentProviderProps = PropsWithChildren & {
	introText?: string;
	highlights?: string;
	methodology?: string;
	dataAppendix?: string;
	lastUpdated?: string;
	sectionHeadings?: Record<string, string>;
	ussenateData?: string;
	ussenateDataDonorMoney?: string;
	ushouseData?: string;
	ushouseDataDonorMoney?: string;
	ussenateDataDonorCont?: string;
	ushouseDataDonorCont?: string;
};

export const PageContentProvider = ({
	children,
	introText,
	highlights,
	methodology,
	dataAppendix,
	lastUpdated,
	sectionHeadings = {},
	ussenateData,
	ussenateDataDonorMoney,
	ushouseData,
	ushouseDataDonorMoney,
	ussenateDataDonorCont,
	ushouseDataDonorCont
}: PageContentProviderProps) => {
	const value: PageContentContextInterface = {
		introText,
		highlights,
		methodology,
		dataAppendix,
		lastUpdated,
		sectionHeadings,
		ussenateData,
		ussenateDataDonorMoney,
		ushouseData,
		ushouseDataDonorMoney,
		ussenateDataDonorCont,
		ushouseDataDonorCont
	};

	return (
		<PageContentContext.Provider value={value}>
			{children}
		</PageContentContext.Provider>
	);
};

export const usePageContent = (): PageContentContextInterface => {
	const context = useContext(PageContentContext);
	if (context === undefined) {
		throw new Error('usePageContent must be used within a PageContentProvider');
	}
	return context;
};